import TimelineFollows from "@/Components/Feed/TimelineFollows";

export const ConversationsTab = () => {
  return <TimelineFollows postsOnly={false} />;
};
